import { cn } from "@paribus/shared-ui";
import React from "react";

export interface VisitsToolbarSwitchProps {
  "aria-label": string;
  pressed: boolean;
  onPressedChange: () => void;
  label: React.ReactNode;
  variant: "blue" | "red";
}

const variantClasses: Record<
  VisitsToolbarSwitchProps["variant"],
  { track: string; focus: string }
> = {
  blue: {
    track: "bg-primary",
    focus: "focus-visible:shadow-focus",
  },
  red: {
    track: "bg-destructive",
    focus: "focus:outline-none focus-visible:shadow-focus-danger",
  },
};

export const VisitsToolbarSwitch: React.FC<VisitsToolbarSwitchProps> = ({
  "aria-label": ariaLabel,
  pressed,
  onPressedChange,
  label,
  variant,
}) => {
  const { track, focus } = variantClasses[variant];
  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        role="switch"
        aria-label={ariaLabel}
        aria-checked={pressed}
        onClick={onPressedChange}
        className={cn(
          "relative inline-flex h-5 w-9 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-300 ease-in-out",
          focus,
          pressed ? track : "bg-neutral-200"
        )}
      >
        <span
          className={cn(
            "pointer-events-none inline-block h-4 w-4 transform rounded-full bg-card shadow-md ring-0 transition-transform duration-300 ease-in-out",
            pressed ? "translate-x-4" : "translate-x-0"
          )}
        />
      </button>
      <span className="text-2xs font-semibold uppercase tracking-micro text-neutral-500">
        {label}
      </span>
    </div>
  );
};
